jQuery(document).ready(function(){
    jQuery('input, select').each(function(){
        let input = jQuery(this);
        checkInput(input);
        input.keyup(function(){checkInput(input)});
        input.focusout(function(){checkInput(input)})
        input.focusin(function(){checkInput(input)})
    });
    jQuery('.wp-block-vif-glossaire-container form.vif-glossaire-keys').each(function(){
        let currentForm = jQuery(this);
        currentForm.find('input').click(function(){
            currentForm.submit();
        })
    })
    checkSolutionsSearchForm();
}) 

function checkInput(input){
    if(input && (input.val() || input.is(':focus'))) input.parent().parent().addClass('active');
    else input.parent().parent().removeClass('active');
}


function checkSolutionsSearchForm(){
    let forms = jQuery('form.solutions-search-engine');
    forms.each(function(){
        let currentForm = jQuery(this);
        currentForm.submit(function(e){
            let allFill = true;
            currentForm.find('select').each(function(){
                if(jQuery(this).find(':selected').prop('disabled')) allFill = false;
            })
            if(!allFill){
                e.preventDefault();
                e.stopPropagation();
                currentForm.addClass('not-fill')
                return false;
            }
        })
    })
}